import { TemplateComponentsProps } from '@zonofi/common/hooks/render-template-ui';
import { renderTextWithLinks } from './helpers';
import { FileParams } from '@zonofi/common/types/interface';
import { ImageView } from './image-view';
import { DocumentView } from './document-view';

export const TemplateComponents: TemplateComponentsProps = {
  video: (_x: string, _y: string, file?: FileParams[]) =>
    file ? (
      <div className="msg-contents-node">
        {file.map((f) => (
          <DocumentView {...f} />
        ))}
      </div>
    ) : null,
  image: (_x: string, _y: string, file?: FileParams[]) => {
    return file ? (
      <div className="msg-contents-node">
        {file.map((f) => (
          <ImageView {...f} />
        ))}
      </div>
    ) : null;
  },
  header: (_: string, text: string) => <MessageBody text={text} />,
  body: (templateName: string, text: string) => (
    <MessageBody text={text} templateName={templateName} />
  ),
  document: (_x: string, _y: string, file?: FileParams[]) =>
    file ? (
      <div className="msg-contents-node">
        {file.map((f) => (
          <DocumentView {...f} />
        ))}
      </div>
    ) : null,
  audio: (_x: string, _y: string, file?: FileParams[]) =>
    file ? (
      <div className="msg-contents-node">
        {file.map((f) => (
          <DocumentView {...f} />
        ))}
      </div>
    ) : null,
  banner: () => null,
  footer: (_: string, text: string) => <MessageBody text={text} />,
  button: () => null,
  location: (_: string, text: string) => <MessageBody text={text} />,
  contact: (_: string, text: string) => <MessageBody text={text} />,
};

interface MessageBodyProps {
  text: string;
  templateName?: string;
}

const MessageBody: React.FC<MessageBodyProps> = ({ text, templateName }) => {
  if (text.length === 0) return null;
  const parts = (text || '')?.split(/(\*.*?\*|_.*?_)/g) || [];

  return (
    <div
      key="body"
      className={
        templateName?.toLowerCase() === 'unknown'
          ? 'msg-contents-node-body font-italic'
          : 'msg-contents-node-body font-regular'
      }
    >
      {parts.map((part, index) => {
        if (part.startsWith('*') && part.endsWith('*')) {
          return (
            <span key={index} className="msg-contents-node-body font-semiBold">
              {renderTextWithLinks(part.slice(1, -1))}
            </span>
          );
        } else if (part.startsWith('_') && part.endsWith('_')) {
          return (
            <span
              key={index}
              className="msg-contents-node-body font-regular font-italic"
            >
              {renderTextWithLinks(part.slice(1, -1))}
            </span>
          );
        } else {
          return (
            <span key={index} className="msg-contents-node-body">
              {renderTextWithLinks(part)}
            </span>
          );
        }
      })}
    </div>
  );
};
